module.exports = __webpack_public_path__ + "img/pro_capture4.b50df160.png";